import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box, Divider, IconButton, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {ExportField} from '../../interfaces/Export';
import ExportPdfButton from '../common/ExportPdfButton';
import ModalFixed from '../common/ModalFixed';
import CommunicationNodeTrackingExportExcel from '../dashboard-panels/CommtracNodeTrackingReports/CommunicationNodeTrackingExportExcel';
import {CommtracNodesReportData} from '../dashboard-panels/ConnectView/CommtracNodesReport';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  value?: CommtracNodesReportData;
  exportFields?: ExportField[];
  onSubmitted?: () => void;
}

const CommunicationNodeTrackingReportExportButton = <T extends ComponentType>({
  componentProps,
  children,
  exportFields,
}: Props<T>) => {
  const [isOpened, setIsOpened] = useState(false);

  const params = {
    external_id: componentProps?.external_id,
    date_start: componentProps?.date_start,
    date_end: componentProps?.date_end,
    message_type: componentProps?.message_type,
  };

  return (
    <>
      <Tooltip title="Export">
        <FileDownloadIcon {...componentProps} onClick={() => setIsOpened(true)}>
          {children}
        </FileDownloadIcon>
      </Tooltip>

      {isOpened ? (
        <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            gap={3}
            p={3}
          >
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" alignItems="center" width="100%" gap={1.5}>
                <FileDownloadIcon sx={{color: 'primary.main'}} />
                <Box fontSize={24}>Export History</Box>
              </Box>
              <IconButton onClick={() => setIsOpened(false)}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              position="relative"
              gap={3}
            >
              <Divider>Export</Divider>
              <CommunicationNodeTrackingExportExcel
                value={{
                  ...componentProps,
                  exportFields: exportFields ?? [],
                  shownFields: [],
                  selectedIds: componentProps?.external_id,
                  params: {...componentProps},
                }}
              />
              <ExportPdfButton
                endpoint="/communication-node/event-grid"
                defaultFilename="communication_node_history.pdf"
                params={params}
                exportFields={exportFields}
              />
            </Box>
          </Box>
        </ModalFixed>
      ) : null}
    </>
  );
};

export default CommunicationNodeTrackingReportExportButton;
